import * as React from 'react';
import { Colors, Box, Heading2, Text, BREAK_POINTS } from '@origin-digital/style-guide';
import styled from 'styled-components';

export const Wrapper = styled(Box)`
  width: 100%;
  background-size: 40px 40px;
  background-position: 50% 50%;
  background-color: #fff3df;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80'%3e %3cpath fill='white' fill-rule='evenodd' d='M0 80V0h80v80H0zm56-40a16 16 0 1 0-32 0 16 16 0 0 0 32 0zm-7.7 0a8.3 8.3 0 0 1-8.3 8.3 8.3 8.3 0 0 1-8.3-8.3 8.3 8.3 0 0 1 8.3-8.3 8.3 8.3 0 0 1 8.3 8.3z'/%3e %3c/svg%3e");
  border-top: solid 1px ${Colors.GREY16};
  border-bottom: solid 1px ${Colors.GREY16};

  // @media only screen and (min-width: ${BREAK_POINTS.Min.SM}) {
    padding-left: 42px;
    padding-right: 42px;
  // }

  @media only screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    padding: 22px 0;
  }

  @media only screen and (min-width: ${BREAK_POINTS.Min.XL}) {
    padding: 32px 0;
  }
`;

const Banner: React.StatelessComponent<BannerProps> = ({ title, subtitle }: BannerProps): JSX.Element => {
  return (
    <Box marginBottom={6}>
      <Wrapper>
        <Box marginTop={8} marginBottom={8}>
          <Box marginBottom={4}>
            <Heading2 text={title} align={'center'} fontWeight={'bold'} accessibilityLevel={1} />
          </Box>
          {subtitle ? (
            <Text size={'sm'} align={'center'} color={'grey56'}>
              {subtitle}
            </Text>
          ) : null}
        </Box>
      </Wrapper>
    </Box>
  );
};

export { Banner as default };
